import React from "react";
import { Close as ClosePrimitive } from "@radix-ui/react-toast";
import { ToastCloseProps } from "./Toast.types";
import { Layout } from "./Close.styles";

/**
 * Close button for dismissing toasts
 */
export const Close = (props: ToastCloseProps) => (
  <ClosePrimitive asChild>
    <Layout {...props} />
  </ClosePrimitive>
);
